<!-- CHATBOT PANEL -->
<div
  ref="chatbot"
  class="
    position-fixed bottom-0 end-0
    bg-opacity-90
    bg-collapsable-btn
    shadow-lg
    border
    rounded-4
    d-flex flex-column
    overflow-hidden
    z-3
    chatbot-panel
  "
  :class="{
    'chatbot-open': is_open,
    'chatbot-closed': !is_open,
    'chatbot-fullscreen': is_fullscreen,
    'chatbot-history-collapsed': !is_history_open
  }"
  role="dialog"
  aria-modal="true"
>
  <BolideAssistantHeader
    :title="active_conversation_title"
    :is_fullscreen="is_fullscreen"
    :is_history_open="is_history_open"
    @toggle-history="toggle_history"
    @new-conversation="start_new_conversation"
    @toggle-fullscreen="toggle_fullscreen"
    @close="close_assistant"
  />

  <div class="chatbot-content d-flex flex-column flex-md-row flex-grow-1 overflow-hidden min-h-0">
    <BolideAssistantHistory
      :conversations="conversations"
      :active_conversation_id="active_conversation_id"
      :is_open="is_history_open"
      :has_more_conversations="!!chat_history_next_cursor"
      :is_loading_conversations="is_loading_chat_history"
      @new-conversation="start_new_conversation"
      @select-conversation="select_conversation"
      @delete-conversation="delete_conversation"
      @load-more-conversations="load_more_conversations"
    />

    <section class="chatbot-main flex-grow-1 d-flex flex-column min-w-0 min-h-0">
      <BolideAssistantMessages
        ref="chat_messages"
        :messages="messages"
        :has_older_messages="!!(active_conversation && active_conversation.messages_next_cursor)"
        :is_loading_older_messages="!!(active_conversation && active_conversation.is_loading_messages)"
        @load-older-messages="load_older_active_messages"
      />

      <BolideAssistantComposer
        :model_value="user_message"
        :disabled="is_sending"
        :placeholder="composer_placeholder"
        :scope="scope"
        :compare_property_options="compare_property_options"
        :compare_property_ids="compare_property_ids"
        @update:model_value="user_message = $event"
        @update:compare_property_ids="$emit('update:compare_property_ids', $event)"
        @send="send"
      />
    </section>
  </div>
</div>
